import { GamoraFoundationError } from '../foundation/error/error.js';

/**
 * Unhandled exceptions
 * @type Error
 */
export class GamoraErrorUnhandledException extends GamoraFoundationError {
  constructor(message?: string) {
    super(message);
  }
}
